module.exports = __webpack_public_path__ + "img/gradle.00591818.svg";